export default "__VITE_ASSET__kocpANLd__"